export default "__VITE_ASSET__DNg3CSHM__"